// extracted by mini-css-extract-plugin
module.exports = {"socialButton":"PlatformButton_socialButton__-mvUA","socialIcon":"PlatformButton_socialIcon__1I-u9"};